import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "app-related-courses",
    templateUrl: "./related-courses.component.html",
    styleUrls: ["./related-courses.component.scss"],
})
export class RelatedCoursesComponent implements OnInit {
    private destroyRef = inject(DestroyRef);
    constructor(private route: ActivatedRoute) {}
    pageData = "";
    ngOnInit(): void {
        this.route.data
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
                switch (data.kind) {
                    case "kepler-introduction": {
                        this.pageData = "kepler-introduction";
                        this.sectionTitle = [
                            {
                                title: "Learning Where You Work",
                            },
                        ];
                        break;
                    }
                    case "university-kepler": {
                        this.pageData = "university-kepler";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "university-kepler-deeper": {
                        this.pageData = "university-kepler-deeper";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "kusto-insights": {
                        this.pageData = "kusto-insights";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "Kepler-data-eng": {
                        this.pageData = "Kepler-data-eng";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "Kepler-data-ana": {
                        this.pageData = "Kepler-data-ana";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "airflow-training": {
                        this.pageData = "airflow-training";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "snowflake-datawarehousing": {
                        this.pageData = "snowflake-datawarehousing";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "snowflake-datavisualization": {
                        this.pageData = "snowflake-datavisualization";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "azure-datafactory": {
                        this.pageData = "azure-datafactory";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "azure-createdatafactory": {
                        this.pageData = "azure-createdatafactory";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "university-uda": {
                        this.pageData = "university-uday";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "university-mdp": {
                        this.pageData = "university-mdp";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "azure-createpipeline": {
                        this.pageData = "azure-createpipeline";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "azure-databricks": {
                        this.pageData = "azure-databricks";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "openshift-basics": {
                        this.pageData = "openshift-basics";
                        this.sectionTitle = [
                            {
                                title: "",
                            },
                        ];
                        this.singleCoursesBox = [];
                        break;
                    }
                    case "university-snowflake": {
                        this.pageData = "university-snowflake";
                        this.singleCoursesBox = [
                            {
                                courseImg: "assets/img/courses/img1.jpg",
                                coursePrice: "Free",
                                coursePriceClass: "free",
                                authorImg: "assets/img/user1.jpg",
                                authorName: "Alex Morgan",
                                title: "Snowflake - Data Warehousing",
                                link: "snowflake-datawarehousing",
                                paragraphText:
                                    "The Data Warehousing Workshop is designed for learners who are new to Snowflake, or new to databases in general. This workshop is highly interactive with reflection questions, hands on lab work and automated lab work checks ! This course is fast-paced and informative, light in tone, scenario-driven and metaphor rich.",
                                courseDuration: "8 Hours",
                                studentApply: "Self-Paced",
                            }, //,
                            // {
                            //     courseImg: 'assets/img/courses/img2.jpg',
                            //     coursePrice: '$49',
                            //     coursePriceClass: 'paid',
                            //     authorImg: 'assets/img/user2.jpg',
                            //     authorName: 'Sarah Taylor',
                            //     title: 'Snowflake - Data Visualization',
                            //     link: 'snowflake-datavisualization',
                            //     paragraphText: 'A Snowflake Warehouse is a virtual warehouse consisting of one or more compute clusters that enable customers to execute queries, load data, and perform other DML operations. Snowflake credits are used to pay for the processing time used by each virtual warehouse.Warehouses are required for queries, DML operations',
                            //     courseDuration: 'TBD',
                            //     studentApply: 'Self-Paced'
                            // }
                        ];
                        break;
                    }
                    case "azure-dataexplorer": {
                        this.pageData = "azure-dataexplorer";
                        this.singleCoursesBox = [
                            {
                                courseImg: "assets/img/courses/img1.jpg",
                                coursePrice: "Free",
                                coursePriceClass: "free",
                                authorImg: "assets/img/user1.jpg",
                                authorName: "Alex Morgan",
                                title: "Azure Data Factory (ADF)",
                                link: "azure-datafactory",
                                paragraphText:
                                    "Azure Data Factory is a fully managed, serverless data integration service. Learn how to visually integrate data sources with many built-in, maintenance-free connectors.",
                                courseDuration: "35 minutes",
                                studentApply: "Self-Paced",
                            },
                            {
                                courseImg: "assets/img/courses/img2.jpg",
                                coursePrice: "$49",
                                coursePriceClass: "paid",
                                authorImg: "assets/img/user2.jpg",
                                authorName: "Sarah Taylor",
                                title: "ADF - Create a data factory",
                                link: "azure-createdatafactory",
                                paragraphText:
                                    "This course describes how to use the ADF user interface to create and monitor a data factory. The pipeline created in this data factory copies data from one folder to another folder in Azure Blob storage.",
                                courseDuration: "60 minutes",
                                studentApply: "Self-Paced",
                            },
                            {
                                courseImg: "assets/img/courses/img1.jpg",
                                coursePrice: "Free",
                                coursePriceClass: "free",
                                authorImg: "assets/img/user1.jpg",
                                authorName: "Alex Morgan",
                                title: "ADF - Creating/Managing Data Pipelines",
                                link: "azure-createpipeline",
                                paragraphText:
                                    "This learning path explores how to create and manage data pipelines in the cloud using Azure Data Factory including triggering the pipeline .",
                                courseDuration: "6 Hours",
                                studentApply: "Self-Paced",
                            },
                            {
                                courseImg: "assets/img/courses/img2.jpg",
                                coursePrice: "$49",
                                coursePriceClass: "paid",
                                authorImg: "assets/img/user2.jpg",
                                authorName: "Sarah Taylor",
                                title: "Azure - Explore Databricks",
                                link: "azure-databricks",
                                paragraphText:
                                    "Azure Databricks is a cloud service that provides a scalable platform for data analytics using Apache Spark.",
                                courseDuration: "45 minutes",
                                studentApply: "Self-Paced",
                            },
                        ];
                        break;
                    }
                    case "university-kusto": {
                        this.pageData = "university-kusto";
                        this.singleCoursesBox = [
                            {
                                courseImg: "assets/img/courses/img1.jpg",
                                coursePrice: "Free",
                                coursePriceClass: "free",
                                authorImg: "assets/img/user1.jpg",
                                authorName: "Alex Morgan",
                                title: "Kusto Query Language -  Gain insights from your data by using",
                                link: "kusto-insights",
                                paragraphText:
                                    "Write advanced queries in Kusto Query Language to help you gain insights from your data. Use the aggregation functions count, dcount, countif, sum, min, max, avg, percentiles, and others. Communicate these results visually in charts",
                                courseDuration: "50 minutes",
                                studentApply: "Self-Paced",
                            },
                        ];

                        break;
                    }
                    case "openshift-foundation": {
                        this.pageData = "openshift-foundation";
                        this.singleCoursesBox = [
                            {
                                courseImg: "assets/img/courses/img1.jpg",
                                coursePrice: "Free",
                                coursePriceClass: "free",
                                authorImg: "assets/img/user1.jpg",
                                authorName: "Alex Morgan",
                                title: "Azure Red Hat OpenShift Basics",
                                link: "openshift-basics",
                                paragraphText:
                                    "This course provides hands-on experience creating and deploying applications in Red Hat OpenShift in Red Hat's interactive learning environments.",
                                courseDuration: "50 minutes",
                                studentApply: "Self-Paced",
                            },
                        ];

                        break;
                    }
                    case "default": {
                        this.pageData = "University";
                        sectionTitle: [
                            {
                                title: "More Courses You Might Like",
                            },
                        ];
                        break;
                    }
                }
            });
    }

    sectionTitle: sectionTitleContent[] = [
        {
            title: "More Courses You Might Like",
        },
    ];
    singleCoursesBox: coursesContent[] = [
        {
            courseImg: "assets/img/courses/img1.jpg",
            coursePrice: "Free",
            coursePriceClass: "free",
            authorImg: "assets/img/user1.jpg",
            authorName: "Alex Morgan",
            title: "Introduction to Quantitative Methods",
            link: "courses-details",
            paragraphText:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.",
            courseDuration: "8 Weeks Long",
            studentApply: "Available Now",
        },
        {
            courseImg: "assets/img/courses/img2.jpg",
            coursePrice: "$49",
            coursePriceClass: "paid",
            authorImg: "assets/img/user2.jpg",
            authorName: "Sarah Taylor",
            title: "Introduction to Linear Models and Matrix Algebra",
            link: "courses-details",
            paragraphText:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.",
            courseDuration: "7 Weeks Long",
            studentApply: "Available Now",
        },
        {
            courseImg: "assets/img/courses/img3.jpg",
            coursePrice: "$69",
            coursePriceClass: "paid",
            authorImg: "assets/img/user3.jpg",
            authorName: "David Warner",
            title: "Data Science: Inference and Modeling",
            link: "courses-details",
            paragraphText:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.",
            courseDuration: "2 Weeks Long",
            studentApply: "Not Available",
        },
        {
            courseImg: "assets/img/courses/img1.jpg",
            coursePrice: "Free",
            coursePriceClass: "free",
            authorImg: "assets/img/user1.jpg",
            authorName: "Alex Morgan",
            title: "Introduction to Quantitative Methods",
            link: "courses-details",
            paragraphText:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.",
            courseDuration: "8 Weeks Long",
            studentApply: "Available Now",
        },
        {
            courseImg: "assets/img/courses/img2.jpg",
            coursePrice: "$49",
            coursePriceClass: "paid",
            authorImg: "assets/img/user2.jpg",
            authorName: "Sarah Taylor",
            title: "Introduction to Linear Models and Matrix Algebra",
            link: "courses-details",
            paragraphText:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.",
            courseDuration: "7 Weeks Long",
            studentApply: "Available Now",
        },
        {
            courseImg: "assets/img/courses/img3.jpg",
            coursePrice: "$69",
            coursePriceClass: "paid",
            authorImg: "assets/img/user3.jpg",
            authorName: "David Warner",
            title: "Data Science: Inference and Modeling",
            link: "courses-details",
            paragraphText:
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.",
            courseDuration: "2 Weeks Long",
            studentApply: "Not Available",
        },
    ];
}
class coursesContent {
    courseImg: string;
    coursePrice: string;
    coursePriceClass: string;
    authorImg: string;
    authorName: string;
    title: string;
    link: string;
    paragraphText: string;
    courseDuration: string;
    studentApply: string;
}
class sectionTitleContent {
    title: string;
}
